var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"trm-card"},[_c('div',{staticClass:"mdn-Row"},[_c('div',{staticClass:"mdn-Col-lg"},[_c('span',{class:_vm.icon})])]),_c('div',{staticClass:"mdn-Row"},[_c('div',{staticClass:"mdn-Col-lg"},[_c('p',{staticClass:"mdn-Text titulo"},[_c('b',[_vm._v(_vm._s(_vm.titulo))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }